"use strict";
import React from "react";

const initComponent = (flex = window.flex) => {

    class PageAlerts extends React.Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.pageAlerts != this.props.pageAlerts) {
                nextProps.pageAlerts.map((alert, index) => {

                    if (alert.selfCloseTimeout) {
                        setTimeout(() => {
                            flex.removePageAlerts(alert.key, alert.postId);
                        }, alert.selfCloseTimeout);
                    }
                })
            }
        }

        render() {
            const props = this.props;
            const alerts = props.pageAlerts;
            const spanStyle = { padding: "20px", display: "block", fontSize: "12px" };
            const spanStyleDetail = { display: "block", fontSize: "11px" };

            if (!alerts || !alerts.length) return false;
            return (
                <div className="page-alerts">
                    {_.filter(alerts, (alert) => { return alert.isModal; }).length == 0 ? false : (
                        <div style={{ position: "fixed", zIndex: "99998", left: "0", top: "0", width: "100%", height: "100%", background: "#f3f3f4", opacity: ".75", overflow: "auto" }} ></div>
                    )}

                    <div className="page-alerts-container fadeInRight animated" style={{ float: "right", width: "300px", position: "fixed", right: "0", top: "40px", zIndex: "99999" }}>
                        {alerts.map((alert, index) => {
                            let summary = '';
                            const { detail } = alert;

                            if (typeof (alert.summary) === "string") {
                                summary = <span style={spanStyle} >
                                            <span dangerouslySetInnerHTML={{ __html: alert.summary }}></span>
                                            {detail ? <small style={spanStyleDetail}>{detail}</small> : false}
                                          </span>
                            } else {
                                summary = <span style={spanStyle}>
                                            <span>{React.cloneElement(alert.summary)}</span>
                                            {detail ? <small style={spanStyleDetail}>{detail}</small> : false}
                                          </span>
                            }

                            const className = alert.className || "alert-danger";
                            return (
                                <div key={index} className={className} style={{ marginTop: "10px", borderRadius: "10px 0 0 10px", boxShadow: "3px 3px", opacity: "1" }}>
                                    {alert.disableClose ? false : <a className="close page-alert-close" style={{ padding: "10px" }} onClick={() => flex.removePageAlerts(alert.key, alert.postId)}>&times;</a>}
                                    {summary}
                                </div>
                            )
                        })}
                    </div>
                </div>
            );
        }
    }

    return PageAlerts;
};

module.exports = initComponent;
